export const basicInfoFieldsRows = [
  [
    { key: 'invoice', label: 'Invoice Number', dataType: 'string', stringMaxLength: 128 },
    { key: 'grossAmount', label: 'Gross Amount', dataType: 'decimal' },
    { key: 'date', label: 'Invoice Date', dataType: 'date' },
    { key: 'vendorName', label: 'Vendor Name', dataType: 'string', stringMaxLength: 128 }
  ],
  [
    { key: 'calculatedTax', label: 'Sovos Tax' },
    { key: 'vendorTax', label: 'Vendor Tax', dataType: 'decimal' },
    { key: 'dollarVariance', label: 'Dollar Variance' },
    { key: 'percentVariance', label: 'Percent Variance' }
  ]
];

export const otherFieldsRows = [
  [{ key: 'businessUnit', label: 'Business Unit', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'company', label: 'Company', dataType: 'string', stringMaxLength: 40 }],
  [
    { key: 'customAttributeName1', label: 'Custom Attribute Name 1', dataType: 'string', stringMaxLength: 256 },
    { key: 'customAttributeValue1', label: 'Custom Attribute Value 1', dataType: 'string', stringMaxLength: 256 }
  ],
  [
    { key: 'customAttributeName2', label: 'Custom Attribute Name 2', dataType: 'string', stringMaxLength: 256 },
    { key: 'customAttributeValue2', label: 'Custom Attribute Value 2', dataType: 'string', stringMaxLength: 256 }
  ],
  [{ key: 'freightAmount', label: 'Delivery Amount', dataType: 'decimal' }],
  [{ key: 'documentNumber', label: 'Document Number', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'fiscalDate', label: 'Fiscal Date', dataType: 'date' }],
  [{ key: 'headerDescription', label: 'Invoice Description', dataType: 'string', stringMaxLength: 256 }],
  [{ key: 'miscAmount', label: 'Miscellaneous Amount', dataType: 'decimal' }],
  [{ key: 'validationDescription', label: 'Validation Description', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'vendorRate', label: 'Vendor Charged Rate' }],
  [{ key: 'vendorNameExtended', label: 'Vendor Name Extd', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'vendorNumber', label: 'Vendor Number', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'vendorType', label: 'Vendor Type', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'voucherOrigin', label: 'Voucher Origin', dataType: 'string', stringMaxLength: 3 }] 
];

export const uneditableFields = [
  'calculatedTax',
  'dollarVariance',
  'percentVariance',
  'vendorTax',
  'vendorRate',
  'grossAmount'
];


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/InvoiceFieldsHelper.js